export default {
  strict: true,
  namespaced: true,
  state: {
    contoursData:[],
  },
  mutations: {
    setContoursData(state, contoursData) {
      state.contoursData = contoursData;
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/map/data/contours.js